import { ArticleTimeUnitKind } from '../model/const/enums';
import { getNumberOfDays } from '../../core/helper/date-time';
import { Money } from '../../core/model/money';

export function getYearAmount(amount: Money, tUnit: ArticleTimeUnitKind, numberOfChargedMonthsInYear: number): Money {
  let yearRent = 0;
  switch (tUnit) {
    case ArticleTimeUnitKind.Hour:
      yearRent = amount.amount * 360 * 24;
      break;
    case ArticleTimeUnitKind.Day:
      yearRent = amount.amount * 360;
      break;
    case ArticleTimeUnitKind.Month:
      yearRent = amount.amount * 12;
      break;
    case ArticleTimeUnitKind.Quarter:
      yearRent = amount.amount * 4;
      break;
    case ArticleTimeUnitKind.Year:
      yearRent = amount.amount;
      break;
  }

  return new Money(amount.currencyCode, yearRent ? (yearRent * numberOfChargedMonthsInYear) / 12 : 0);
}

export function getPeriodAmount(yearAmount: Money, tUnit: ArticleTimeUnitKind, numberOfChargedMonthsInYear: number): Money {
  let periodRent = 0;
  switch (tUnit) {
    case ArticleTimeUnitKind.Hour:
      periodRent = yearAmount.amount / (360 * 24);
      break;
    case ArticleTimeUnitKind.Day:
      periodRent = yearAmount.amount / 360;
      break;
    case ArticleTimeUnitKind.Month:
      periodRent = yearAmount.amount / 12;
      break;
    case ArticleTimeUnitKind.Quarter:
      periodRent = yearAmount.amount / 4;
      break;
    case ArticleTimeUnitKind.Year:
      periodRent = yearAmount.amount;
      break;
  }

  if (numberOfChargedMonthsInYear === 0) return new Money(yearAmount.currencyCode, 0);

  return new Money(yearAmount.currencyCode, ((periodRent ? periodRent : 0) * 12) / numberOfChargedMonthsInYear);
}
